import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  box: {
    ...dFlex('space-between', 'flex-start'),
    flexDirection: 'column',
    gap: 24,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      gap: 'unset',
      height: '100%',
    },
  },
  btns: {
    ...dFlex('space-between'),
    gap: 24,
    width: '100%',

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      flexDirection: 'column',
    },
  },
  btn: {
    '&.MuiButton-outlined': {
      '&:before': {
        background: theme.gradient.g1,
      },
    },
  },
}));

export default useStyles;
